import { DestroyRef, inject, Injectable } from '@angular/core';
import { AuthenticationService } from '@libs/shared/services/authentication.service';
import { LastApplicationStorage } from '@libs/shared/storage/last-application.storage';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { conditionalOperator } from '@libs/shared/operators/conditional.operator';
import { SESSION_STORAGE } from '@libs/shared/injections/window';
import { NavigationEnd, Router } from '@angular/router';
import { RECONNECT } from '@libs/services/channel.service';
import { Loan } from '@libs/models/loan.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({providedIn: 'root'})
export class HeaderHelper {
  private loanStore = inject(LastApplicationStorage);
  private authService = inject(AuthenticationService);
  private sessionStorage = inject(SESSION_STORAGE);
  private router = inject(Router);
  private destroyRef: DestroyRef = inject(DestroyRef);

  public get isLogoutInsideDropDownVisible(): Observable<boolean> {
    return this.authService.isLoggedIn().pipe(
      switchMap((value: boolean) => this.router.events.pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((event: NavigationEnd) => ({url: event.url, value})),
        takeUntilDestroyed(this.destroyRef),
      )),
      conditionalOperator({
        condition: (data) => data.value && !this.sessionStorage.getItem(RECONNECT.ID) && !data.url.includes('auth'),
        trueCase: () => this.loanStore.get().pipe(map((loan) => !loan.id)),
      }),
    );
  }

  public get isLoanExist(): Observable<boolean> {
    return this.authService.isLoggedIn().pipe(
      conditionalOperator({
        condition: (v) => v,
        trueCase: () => this.loanStore.get().pipe(map((loan) => !!loan.id)),
      }),
      takeUntilDestroyed(this.destroyRef),
    );
  }

  public get payButton(): Observable<{ visible: boolean, loan: Loan }> {
    return this.authService.isLoggedIn().pipe(
      conditionalOperator({
        condition: (v) => v,
        trueCase: () => this.loanStore.get(true).pipe(map((loan) => ({
          visible: Boolean(!!loan?.id && loan?.isPayable),
          loan
        }))),
      }),
      takeUntilDestroyed(this.destroyRef),
    );
  }
}
